
import { parseISO } from "date-fns/parseISO";
import { Button } from "primereact/button";
import { useState, useEffect } from "react";
import { FabrixIcon, translate, useIcon } from "../../..";
import ActivityClock from "../../activity/activity-clock";
import { NTNotification } from "@nt-portal/server-sdk";

export interface FabrixNotification extends NTNotification {
    sendByDisplay: string;
}

export interface NotificationCardProps {
    notification: FabrixNotification;
    onDelete?: (notification: FabrixNotification) => void;
    onMarkRead?: (notification: FabrixNotification) => void;
    className?: string;
    id?: string;
}



/**
 * Normalizes notification timestamps by parsing ISO strings into Date instances.
 * @param value Notification data to normalize.
 * @returns Normalized notification object.
 */
const prepareNotification = (value: FabrixNotification) => {
    let notification = { ...value }

    if (typeof notification.timeStamp === 'string')
        notification.timeStamp = parseISO(notification.timeStamp)

    return notification;
}

/**
 * Renders a notification card showing sender, subject, message, and timestamp.
 * @param props Notification content and optional delete callback.
 * @returns Styled card element describing the notification.
 */
export function NotificationCard(props: NotificationCardProps) {

    const icon = useIcon();
    const [_sender, setSender] = useState<string>('');

    const [_messageHtml, setMessageHtml] = useState<string>('')
    const [_subjectHtml, setSubjectHtml] = useState<string>('');
    const [_notification, setNotification] = useState<FabrixNotification>(prepareNotification(props.notification));


    useEffect(() => {
        let notification = prepareNotification(props.notification)

        setNotification(notification)
    }, [props.notification])

    /**
     * Invokes the delete handler when provided.
     */
    const handleDelete = () => {
        if (props.onDelete)
            props.onDelete(_notification)
    }

    const handleMarkRead = () => {
        if (props.onMarkRead)
            props.onMarkRead(_notification)
    }


    useEffect(() => {

        if (_notification && _notification.timeStamp) {

            if (_notification.messageTemplate) {
                let template = _notification.messageTemplate as any;
                setMessageHtml(template.message);
                setSubjectHtml(template.subject);
            } else {
                setMessageHtml('');
                setSubjectHtml('');
            }
        }

    }, [_notification])





    return (

        <div className={`ntf-card ${props.className ?? ''}`} id={props.id}>

            <div className="ntf-card-content">

                <div className={`ntf-card-header flex justify-content-between ${_notification.read ? '' : 'nft-card-header-unread'}` }>
                    <div>
                        <span className={`${icon(FabrixIcon.user)} ntf-icon `}></span>
                        <span className='ntf-label'>{_notification.sendByDisplay}</span>
                    </div>

                    {/* <div>{_notification.id}</div> */}

                    <span className="p-mr-2 flex ntf-card-subject" dangerouslySetInnerHTML={{
                        __html: _subjectHtml
                    }}></span>

                    <span className="flex">
                        <ActivityClock className="ntf-clock" icon={FabrixIcon.calendar} time={_notification?.timeStamp} />
                    </span>
                </div>

                <div className="ntf-card-message" dangerouslySetInnerHTML={{
                    __html: _messageHtml
                }}></div>


                <div className="ntf-delete-button">
                    {props.onMarkRead && (
                        <Button icon={icon(FabrixIcon.mail)} disabled={_notification.read} title={translate("MARK_AS_READ")} className="p-button-rounded p-button-text fbx-action-button" onClick={handleMarkRead} ></Button>
                    )}
                    {props.onDelete && (
                        <Button icon={icon(FabrixIcon.delete)} title={translate("DELETE")} className="p-button-rounded p-button-text fbx-action-button" onClick={handleDelete} ></Button>
                    )}
                </div> 






            </div>


        </div>



    )
}